import "@/filters";
import router from "@/router";
import store from "@/store/index";
import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import "./plugins/vuetify";
import { msalService } from "./auth/msalService";

Vue.config.productionTip = false;

async function bootstrap() {
  try {
    // Call Vuex action to load the config before mounting the app
    await store.dispatch("loadAuthenticationConfiguration");

    if (
      store.getters.authenticationConfiguration.authenticationType === "msal"
    ) {
      // Wait for MSAL to finish processing redirect
      await msalService.initialize();
    }

    // Mount Vue instance
    new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount("#app");
  } catch (err) {
    console.error("Failed to load configuration:", err);
  }
}

bootstrap();
